// Typelizer digest e1fc3869f21e3cf7cb3fa29e1725f5df
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/documents/:document_id/cash_payment */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/cash_payment', params, options),
    method: 'post',
  }),
}
